module.exports = __webpack_public_path__ + "img/imagenBecas.3dde677f.jpg";